export var ImageScaleType;
(function (ImageScaleType) {
    ImageScaleType[ImageScaleType["FILL"] = 0] = "FILL";
    ImageScaleType[ImageScaleType["FIT"] = 1] = "FIT";
    ImageScaleType[ImageScaleType["CROP"] = 2] = "CROP";
})(ImageScaleType || (ImageScaleType = {}));
//# sourceMappingURL=ImageSDKConfig.js.map